import { render } from "./SideMenuLayout.vue?vue&type=template&id=ba155ac2&ts=true"
import script from "./SideMenuLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideMenuLayout.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/SideMenuLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba155ac2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba155ac2', __exports__)) {
    api.reload('ba155ac2', __exports__)
  }
  
  module.hot.accept("./SideMenuLayout.vue?vue&type=template&id=ba155ac2&ts=true", () => {
    api.rerender('ba155ac2', render)
  })

}


export default __exports__